import { OfferingsProps } from '@jbhi-fi/apis/src/services/types';
import { InfoCalloutBlockProps } from '../InfoCalloutBlock/InfoCalloutBlock';
import { format } from 'date-fns';
import { IconName } from '@jbhi-fi/lanyard-ui/components/Icon';

type splitDisclosureTextResult = {
  disclosureText: string;
  addToCartDisclosureText: string;
};

export const splitDisclosureText = (disclosureText: string | null | undefined = null): splitDisclosureTextResult => {
  const splitString = disclosureText?.split('\r\n\r\n');
  return {
    disclosureText: splitString?.[0] ?? '',
    addToCartDisclosureText: splitString?.[1] ?? '',
  };
};

export const generateIncludedWarranties = (offering: OfferingsProps) => {
  const warranties = offering.suggestedWarrantyPeriods?.filter(
    swp => swp.name?.includes('Manufacturer') || swp.name?.includes('Voluntary Warranty')
  );
  return warranties?.map(warranty => {
    const isManufacturerWarranty = warranty?.name?.toLowerCase().includes('manufacturer');
    const tooltip = isManufacturerWarranty ? warranty.tooltip : undefined;
    return {
      heading: `${
        warranty.period?.includes('1') ? warranty.period?.replace('(s)', '') : warranty.period?.replace('(s)', 's')
      } ${warranty?.name}`,
      dateString: `${format(Date.parse(warranty?.fromDate ?? ''), 'd MMM yyyy')} to ${format(
        Date.parse(warranty?.endDate ?? ''),
        'd MMM yyyy'
      )}`,
      tooltip,
    };
  });
};

export const generateHeadingFeatures = ({
  offering,
  isExtraCare,
  isExtraCareReplacementCover,
}: {
  offering: OfferingsProps;
  isExtraCare?: boolean;
  isExtraCareReplacementCover?: boolean;
}): InfoCalloutBlockProps['features'] => {
  const coveragePeriod = Number(offering.additionalCoveragePeriod?.replace(/[^\d+]/g, '') || 0);

  if (isExtraCare) {
    const fromDate =
      offering.suggestedWarrantyPeriods?.find(swp => swp?.name?.startsWith('JB Hi-Fi Extra Care:'))?.fromDate ?? '';
    const endDate =
      offering.suggestedWarrantyPeriods?.find(swp => swp?.name?.startsWith('JB Hi-Fi Extra Care:'))?.endDate ?? '';
    const periodOfCoverString =
      fromDate && endDate
        ? `**Period of cover:** ${format(Date.parse(fromDate), 'd MMM yyyy')} to ${format(
            Date.parse(endDate),
            'd MMM yyyy'
          )} ${
            isExtraCareReplacementCover
              ? 'starting 12 months after delivery / collection.'
              : "starting after the expiry of the manufacturer's warranty and JB Hi-Fi Minimum Voluntary Warranty."
          }`
        : '';
    return isExtraCareReplacementCover
      ? [
          {
            iconName: 'ArrowCircle' as IconName,
            description: offering.shortDescription ?? '',
          },
          ...(periodOfCoverString
            ? [
                {
                  iconName: 'CalendarEmpty' as IconName,
                  description: periodOfCoverString,
                  subText:
                    'For more info about the manufacturer’s warranty and JB Hi-Fi Minimum Voluntary Warranty (which may entitle you to a free remedy if your product is faulty), see ‘Warranties included with your product’ below.',
                },
              ]
            : []),
        ].filter(Boolean)
      : [
          {
            iconName: 'SpannerSingleHead',
            description: offering.shortDescription ?? '',
          },
          ...(periodOfCoverString
            ? [
                {
                  iconName: 'CalendarEmpty' as IconName,
                  description: periodOfCoverString,
                  subText:
                    'For more info about the manufacturer’s warranty and JB Hi-Fi Minimum Voluntary Warranty (which may entitle you to a free remedy if your product is faulty), see ‘Warranties included with your product’ below.',
                },
              ]
            : []),
        ];
  } else {
    return [
      {
        iconName: 'CalendarEmpty',
        description: `**Duration:** ${coveragePeriod * 12} months`,
      },
    ];
  }
};
